import { render, staticRenderFns } from "./JobOffersNotificationButton.vue?vue&type=template&id=77d0f50a&scoped=true&"
import script from "./JobOffersNotificationButton.vue?vue&type=script&lang=js&"
export * from "./JobOffersNotificationButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d0f50a",
  null
  
)

export default component.exports